<ng-template #defaultTabButtons let-c="close" let-d="dismiss">

    <div class="backgroundTable text-white" ngbAutofocus>


    <div class=" mx-5 ">
        <div class="row my-2">
          <div class="col-9 align-self-center p-2 bd-highlight">Vincular al grupo</div>

          <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger "><i class="fa-solid fa-xmark fa-xl"></i></button></div>
        </div>
      </div>
    <div class="componente-importantes-from">
    <div class="text-center mb-2">Seleccione la acción</div>
            <div class="form-check form-check-inline mx-5" >
                <label class="form-check-label" for="inlineRadio1">Seleccionar grupo</label>
                <input class="form-check-input" checked  (click)="vincularGroup()" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1">
              </div>
              <div class="form-check form-check-inline mx-5">
                <label class="form-check-label" for="inlineRadio2">Crear grupo</label>
                <input class="form-check-input" type="radio" (click)="nuevoGroup()" name="inlineRadioOptions" id="inlineRadio2" value="option2">
              </div>
    <form *ngIf="conGrupo" action="" method="post"  [formGroup]="vincularEquipFormV">
   

        <div class="container mt-2 mx-5">
            

              <div *ngIf="conGrupo" class="form-group col-10">
                <div class="d-flex justify-content-start mt-4 mb-2">
                    <label for="endDate" class="text-white">Seleccione grupo </label>
                </div>
                <select required class="custom-outline-input form-control" id="id_group" formControlName="id_group" >
                <option [ngValue]="0" value="">Seleccione grupo</option>
                <option *ngFor="let group of listGroup" [ngValue]="group.id">
                    {{group.name}}
                  </option>
                
              </select>
            </div>
            
            
            <br>
        </div>   
        
        
        
    </form>
   
    <form action="" *ngIf="sinGrupo"  method="post"  [formGroup]="vincularEquipFormN" >
        <div class="componente-importantes-from">
    
            <div class="container mt-2 mx-5">
                
    
                 
                
                <div *ngIf="sinGrupo" class="form-group col-10">
                    <label for="formControlInput" class="form-label mt-2">Nombre del grupo</label>
                    <input type="text" placeholder="Ingrese nombre" id="name_new_group" formControlName="name_new_group"
                    class="form-control custom-outline-input date">

                </div>
                
                
                <br>
            </div>   

           
            
            </div>
        </form>
        
       
    
  </div>
  <div *ngIf="conGrupo" class="form-group d-flex justify-content-center m-2 my-3">                      
    <div >
        <button class="btn btn-outline-light " (click)="formSubmitC()" style="font-size: 15px;"> <i _ngcontent-xfk-c127="" class="fa-solid fa-floppy-disk"></i> Vincular</button>
    </div>
</div>
<div *ngIf="sinGrupo" class="form-group d-flex justify-content-center m-2 my-3">                      
    <div >
        <button class="btn btn-outline-light " (click)="formSubmitS()" style="font-size: 15px;"> <i _ngcontent-xfk-c127="" class="fa-solid fa-floppy-disk"></i> Vincular y Crear</button>
    </div>
</div>
</div>
</ng-template>
